<template>
  <a-modal
      title="专家状态设置"
      :visible="visible"
      :maskClosable="false"
      :width="960"
      destroyOnClose
      @ok="onSave"
      @cancel="$emit('cancel')"
      :confirmLoading="loading">
    <a-form-model :model="form" ref="form" :rules="rules" class="exi_form item_100"
                  :label-col="{ flex: '0 0 150px' }" :wrapper-col="{ span: 24 }">
      <a-form-model-item label="专家状态" prop="expertFlag" v-if="!onlyLeave">
        <dict-radio dict-key="extract_expert_flag" @change="onChangeFlag" v-model="form.expertFlag"></dict-radio>
      </a-form-model-item>
      <a-form-model-item label="请假时间" prop="leaveDate" v-if="ExtractExpertFlagEnum.LEAVE[0]===form.expertFlag ">
        <a-date-picker v-model="form.leaveDate" :format="'YYYY-MM-DD HH:mm'"
                       show-time
                       style="width: 100%"/>
      </a-form-model-item>
      <a-form-model-item label="理由"
                         v-if="[ExtractExpertFlagEnum.AVOID[0],ExtractExpertFlagEnum.LEAVE[0]].includes(form.expertFlag)">
        <a-textarea
            placeholder="请填写理由"
            :atow-size="{minSize:3,maxSize:5}"
            v-model="form.expertFlagReason"/>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import DictRadio from '@/components/dict/DictRadio.vue'
import { ConfirmExpertFlag } from '@/epp/expertmain/selectexpertapply/api/ExpertApplyRequest'
import moment from 'moment'
import { ExtractExpertFlagEnum } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'

const rules = {
  expertFlagReason: [{ required: true, message: '原因不能为空！', trigger: 'change' }],
}

export default {
  name: 'SetExpertFlagModal',
  computed: {
    ExtractExpertFlagEnum () {
      return ExtractExpertFlagEnum
    }
  },
  components: {
    DictRadio
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      rules: rules,
      form: {
        expertFlagReason: undefined,
        expertFlag: undefined,
        id: undefined,
        leaveDate: moment()
      },
      loading: false,
      onlyLeave: false
    }
  },
  methods: {
    //初始化数据
    initData (record,onlyLeave) {
      this.reSet()
      this.form.id = record.id
      this.form.expertFlag = record.expertFlag
      this.form.leaveDate = record.leaveDate && moment(record.leaveDate)
      this.form.expertFlagReason = record.expertFlagReason
      this.onlyLeave = onlyLeave
    },
    //当状态改变时
    onChangeFlag (val) {
      if (ExtractExpertFlagEnum.AVOID[0] === val) {
        this.form.leaveDate = moment()
      }
      if (ExtractExpertFlagEnum.LEAVE[0] === val) {
        this.form.expertFlagReason = undefined
      }
    },
    //重置
    reSet () {
      this.form = {
        expertFlagReason: undefined,
        expertFlag: undefined,
        id: undefined,
        leaveDate: moment()
      }
    },
    //回传输入的值
    onSave () {
      let that = this
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return
        }
        try {
          that.loading = true
          const data = { ...that.form }
          data.leaveDate = data.leaveDate && data.leaveDate.format('YYYY-MM-DD HH:mm:ss')
          let res = await ConfirmExpertFlag(data)
          if (200 !== res.code) {
            this.$message.error('设置失败')
            return
          }
          this.$message.success('设置成功')
          this.$emit('success', res.result)
        } catch (e) {
          this.$message.error(e.message)
        } finally {
          that.loading = false
        }
      })

    }
  }
}
</script>

<style scoped>

</style>
